// §2.5 Page header: t-title left (with an optional t-meta line under it), page actions right, optional filter row
// beneath (grid pages).
export default function PageHeader({ title, meta, actions, filters }) {
  return (
    <header className="ui ui-ph">
      <div className="ui-ph__row">
        <div className="ui-ph__titles"><h1 className="ui-ph__title">{title}</h1>{meta && <p className="ui-ph__meta">{meta}</p>}</div>
        {actions && <div className="ui-ph__actions">{actions}</div>}
      </div>
      {filters && <div className="ui-ph__filters" role="toolbar" aria-label={`${title} filters`}>{filters}</div>}
    </header>
  );
}
